
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CherryBlossomEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (200 + layerIndex * 80) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const speed = (0.4 + layerIndex * 0.1) * 80 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing) {
            const driftP = this.pseudoRandom(x);
            const scrollY = (time * speed) % spacing;
            const scrollX = (time * speed * 0.5) % spacing;
            
            for (let y = y1; y <= y2; y += spacing) {
                const rot = time + x + y;
                const size = (6 + driftP * 10) * scale;
                
                const draw = () => {
                    ctx.save();
                    ctx.translate(x + scrollX, y + scrollY);
                    ctx.rotate(rot);
                    // 5 petals
                    for (let i = 0; i < 5; i++) {
                        ctx.rotate(Math.PI * 2 / 5);
                        ctx.beginPath();
                        ctx.ellipse(size * 0.5, 0, size * 0.5, size * 0.2, 0, 0, Math.PI * 2);
                        ctx.fill();
                    }
                    ctx.restore();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
